import { CondimentInterface } from "../entities/Condiment";

export const transformCondiments = (
  condiments: CondimentInterface[],
): CondimentInterface[] => {
  return condiments.map((item: CondimentInterface) => ({
    ...item,
    meta: {
      selected: false,
      parts: 0,
      percentage: 0,
      grams: 0,
    },
  }));
};
